import { createToastInterface } from 'vue-toastification'

// Toast Notification Component Styles
import 'vue-toastification/dist/index.css'
import '@resources/scss/vue/libs/toastification.scss'

/**
 * NOTE: If you are using other transition them make sure to import it in `src/@resources/scss/vue/libs/notification.scss` from it's source
 */
const options = {
  hideProgressBar: true,
  closeOnClick: false,
  closeButton: false,
  icon: false,
  timeout: 3000,
  transition: 'Vue-Toastification__fade',
}

let toastInterface

export const getAppToast = () => {
  if (!toastInterface) {
    toastInterface = createToastInterface(options)
  }

  return toastInterface
}

export default function setupToast(app) {
  const sharedToast = getAppToast()

  if (app?.config?.globalProperties) {
    app.config.globalProperties.$toast = sharedToast
  }

  if (typeof window !== 'undefined') {
    window.$toast = sharedToast
  }

  return sharedToast
}
